import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/root/workspace/__flow_work/__flow_builds/3ed4544c-3c2a-4c7a-9f23-032dcb22c824/workspace/streffy-middle-office_rVCL/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
 * @Description: 退单管理
 * @Author: rhd
 * @Date: 2025-02-20 13:52:58
 * @LastEditors: rhd
 * @LastEditTime: 2025-04-27 17:58:13
 */
var basePre = 'operation-center';
var pre = 'refund';
var meta = {
  auth: true,
  closable: true,
  showMenu: false,
  refresh: true
};
export default [{
  path: "/".concat(basePre, "/").concat(pre, "/order/refund-detail/:id"),
  title: '订单详情',
  name: 'order-refund-detail',
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '退单详情',
    activePath: "/".concat(basePre, "/").concat(pre, "/refund/order")
  }),
  component: 'pages/operation-center/refund/detail.vue'
}, {
  path: "/".concat(basePre, "/").concat(pre, "/order/balance-detail/:id"),
  title: '订单详情',
  name: 'recharge-balance-detail',
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '退单详情',
    activePath: "/".concat(basePre, "/").concat(pre, "/refund/balance")
  }),
  component: 'pages/operation-center/refund/balance-detail.vue'
}, {
  path: "/".concat(basePre, "/").concat(pre, "/refund/gift-card-detail/:id"),
  title: '礼品卡退单详情',
  name: 'refund-gift-card-detail',
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '退单详情',
    activePath: "/".concat(basePre, "/").concat(pre, "/refund/gift-card")
  }),
  component: 'pages/operation-center/refund/gift-card-detail.vue'
}, {
  path: "/".concat(basePre, "/").concat(pre, "/order/coupon-package-detail/:id"),
  title: '订单详情',
  name: 'refund-coupon-package-detail',
  meta: _objectSpread(_objectSpread({}, meta), {}, {
    title: '退单详情',
    activePath: "/".concat(basePre, "/").concat(pre, "/refund/coupon-package")
  }),
  component: 'pages/operation-center/refund/coupon-package-detail.vue'
}];